import ConfirmationDialog from "../ConfirmationDialog";
import React from "react";

export const ChecklistProjectNADialog = ({...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { props.onClose }
        cancelButton={{
            action: props.onClose,
            label: 'No, Cancel'
        }}
        acceptButton={{
            action: props.onAccept,
            label: 'Yes, Checklist - N/A'
        }}
        header="Do you want to set this project Checklist N/A?"
    />;

export default ChecklistProjectNADialog;